
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * TradingRouteConditionType enum
 */
class TradingRouteConditionType {
  /**
   * Initialize enum with a given value
   * @param {TradingRouteConditionType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof TradingRouteConditionType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!TradingRouteConditionType}
   * @param {!TradingRouteConditionType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradingRouteConditionType)) {
      throw new TypeError('Instance of TradingRouteConditionType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!TradingRouteConditionType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!TradingRouteConditionType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === TradingRouteConditionType.ORDER_SIDE.value) {
      return 'ORDER_SIDE'
    }
    if (this.value === TradingRouteConditionType.ORDER_VOLUME.value) {
      return 'ORDER_VOLUME'
    }
    if (this.value === TradingRouteConditionType.SYMBOL.value) {
      return 'SYMBOL'
    }
    if (this.value === TradingRouteConditionType.SYMBOL_GROUP.value) {
      return 'SYMBOL_GROUP'
    }
    if (this.value === TradingRouteConditionType.ACCOUNT_GROUP.value) {
      return 'ACCOUNT_GROUP'
    }
    if (this.value === TradingRouteConditionType.ACCOUNT_LOGIN.value) {
      return 'ACCOUNT_LOGIN'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!TradingRouteConditionType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!TradingRouteConditionType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!TradingRouteConditionType} Created enum
   */
  static fromObject (other) {
    return new TradingRouteConditionType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
TradingRouteConditionType.ORDER_SIDE = new TradingRouteConditionType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
TradingRouteConditionType.ORDER_VOLUME = new TradingRouteConditionType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
TradingRouteConditionType.SYMBOL = new TradingRouteConditionType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
TradingRouteConditionType.SYMBOL_GROUP = new TradingRouteConditionType(0 + 3)
// noinspection PointlessArithmeticExpressionJS
TradingRouteConditionType.ACCOUNT_GROUP = new TradingRouteConditionType(0 + 4)
// noinspection PointlessArithmeticExpressionJS
TradingRouteConditionType.ACCOUNT_LOGIN = new TradingRouteConditionType(0 + 5)

export { TradingRouteConditionType };

/**
 * Fast Binary Encoding TradingRouteConditionType field model
 */
class FieldModelTradingRouteConditionType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelTradingRouteConditionType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelTradingRouteConditionType}
   * @param {TradingRouteConditionType=} defaults Default value, defaults is new TradingRouteConditionType()
   * @returns {!TradingRouteConditionType} Result value
   */
  get (defaults = new TradingRouteConditionType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new TradingRouteConditionType(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelTradingRouteConditionType}
   * @param {!TradingRouteConditionType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelTradingRouteConditionType };
